import './BetbookProfile.less';
import './Icons.less';

import clsx from 'clsx';
import React from 'react';

import ProfileAvatar from './ProfileAvatar';
import ProfilePost from './ProfilePost';
import ProfileGraphs from './ProfileGraphs';
import ProfileButtonFollow from './ProfileButtonFollow';
import i18n from '../../../common/i18n';
import NuiBox from '../../nui-box/NuiBox';
import { POST_ANALYSIS, POST_TICKET } from '../../betbook/constants';

export default function BetbookProfile({
    profile,
    avatarId,
    nickname,
    following,
    staticUrl,
    showSubscriptionButton,
    simplified,
    onMobile,
    postType
}) {
    const { evaluatedBets, successfulBets, evaluatedTickets, successfulTickets } = profile;
    const nikeAuthor = nickname === 'Niké';

    return simplified ? (
        <NuiBox noPad otherClass="flex justify-between py-20 pl-20 pr-10 mt-20 mb-30">
            <div className="flex">
                <div className="p-rel flex items-center flex-col">
                    <ProfileAvatar avatarId={avatarId} staticUrl={staticUrl} />
                </div>
                <div className="flex flex-col">
                    <div className="flex justify-start flex-col mx-20">
                        <div className="profile-name-simplified text-bold">{nickname}</div>
                    </div>
                    <div className={clsx('flex flex-row ml-20 mt-10 pointer', { 'mb-30': nikeAuthor })}>
                        <ProfilePost
                            nickname={nickname}
                            postType={POST_ANALYSIS}
                            count={profile.analysisPosts}
                            label={i18n('nui.betbook.profile.analysis')}
                            data-atid="betbook-profile-analyses"
                            active={postType === POST_ANALYSIS}
                            simplified
                        />
                        <div className="profile-separator-simplified 20" />
                        <ProfilePost
                            nickname={nickname}
                            postType={POST_TICKET}
                            count={profile.ticketPosts}
                            label={i18n('nui.betbook.profile.tickets')}
                            data-atid="betbook-profile-tickets"
                            active={postType === POST_TICKET}
                            simplified
                        />
                    </div>
                </div>
            </div>
            <div className={clsx('flex', { 'justify-end': simplified })}>
                {!nikeAuthor &&
                (evaluatedBets || successfulBets || evaluatedTickets || successfulTickets) !== undefined ? (
                    <ProfileGraphs
                        evaluatedBets={evaluatedBets}
                        successfulBets={successfulBets}
                        evaluatedTickets={evaluatedTickets}
                        successfulTickets={successfulTickets}
                        simplified
                    />
                ) : null}
                {showSubscriptionButton ? null : (
                    <div className="p-rel pr-10">
                        <ProfileButtonFollow authorNickname={nickname} following={following} simplified />
                    </div>
                )}
            </div>
        </NuiBox>
    ) : (
        <div className="flex items-center justify-center betbook-profile-box">
            <div className="text-extra-bold fs-20 pt-5">{nickname}</div>
            <div className="p-rel mt-30">
                <ProfileAvatar avatarId={avatarId} staticUrl={staticUrl} />
            </div>
            <div
                className={clsx('betbook-profile-description text-center mt-20', {
                    'profile-description-padding': !onMobile
                })}
            >
                {nikeAuthor ? i18n('nui.betbook.profile.description.nikeAuthor') : null}
            </div>
            <div
                className={clsx(
                    'flex flex-row items-center justify-center betbook-profile-post pointer justify-around mt-30',
                    { 'mb-30': nikeAuthor || !evaluatedBets }
                )}
            >
                <ProfilePost
                    nickname={nickname}
                    postType={POST_ANALYSIS}
                    count={profile.analysisPosts}
                    label={i18n('nui.betbook.profile.analysis')}
                    data-atid="betbook-profile-analyses"
                />
                <ProfilePost
                    nickname={nickname}
                    postType={POST_TICKET}
                    count={profile.ticketPosts}
                    label={i18n('nui.betbook.profile.tickets')}
                    data-atid="betbook-profile-tickets"
                />
            </div>
            {!nikeAuthor && (evaluatedBets || successfulBets || evaluatedTickets || successfulTickets) !== undefined ? (
                <ProfileGraphs
                    evaluatedBets={evaluatedBets}
                    successfulBets={successfulBets}
                    evaluatedTickets={evaluatedTickets}
                    successfulTickets={successfulTickets}
                />
            ) : null}
            {showSubscriptionButton ? null : (
                <div className="p-rel">
                    <ProfileButtonFollow authorNickname={nickname} following={following} />
                </div>
            )}
        </div>
    );
}
